import { render, staticRenderFns } from "./EstadoProcesos.vue?vue&type=template&id=6a0a5ac5&"
import script from "./EstadoProcesos.vue?vue&type=script&lang=js&"
export * from "./EstadoProcesos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports